import * as _ from 'lodash'

export type Path = Array<PathStep>
export type PathStep = string | number | Object


export function resolvePathStep<T>(value: T, pathStep: PathStep): keyof T {
  if (typeof pathStep === 'object') {
    return (value instanceof Array ? _.findIndex(value, pathStep as any) : _.findKey(value, pathStep as any)) as keyof T
  } else {
    return pathStep as keyof T
  }
}

export function getAtPath(value: any, path: Path): any {
  if (path.length === 0) {
    return value
  } else {
    const key = resolvePathStep(value, path[0])
    const deeperValue = value[key]
    return getAtPath(deeperValue, path.slice(1))
  }
}

export function setAtPath(value: any, path: Path, valueAtPath: any): any {
  return updateAtPath(value, path, () => valueAtPath)
}

export function updateAtPath(value: any, path: Path, func: (oldValue: any) => any) {
  if (path.length === 0) {
    return func(value)
  } else {
    const key = resolvePathStep(value, path[0])
    const deeperValue = value[key]
    const newDeeperValue = updateAtPath(deeperValue, path.slice(1), func)
    if (newDeeperValue !== deeperValue) {
      const copy = value instanceof Array ? value.slice() : {...value}
      copy[key] = newDeeperValue
      return copy
    } else {
      return value
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/Path.ts